import { UIPick } from "models/Models";
import { TeamPick } from "./TeamPick";


interface Props {
  pick: UIPick;
  onGamesChanged: (pick: UIPick, games: number) => void;
  onTeamSelected: (pick: UIPick, teamId: number) => void;
}

export const SeriesPick = (props: Props) => {
  return (
    <>
      <TeamPick pick={props.pick} prefix="home" onGamesChanged={props.onGamesChanged} onTeamSelected={props.onTeamSelected} />
      <TeamPick pick={props.pick} prefix="away" onGamesChanged={props.onGamesChanged} onTeamSelected={props.onTeamSelected}/>
    </>
  );
};
